import { TileRectangle } from "../../../lib/runescape/coordinates";
import { Raster } from "../../../lib/util/raster";
import { Scans } from "../Scans";
export var ScanProfile;
(function (ScanProfile) {
    function compute(tile, candidates, range) {
        return candidates.map((s) => Scans.Pulse.hash(Scans.get_pulse(tile, s, range)));
    }
    ScanProfile.compute = compute;
    function equals(a, b) {
        if (a.length != b.length)
            return false;
        for (let i = 0; i < a.length; i++) {
            if (a[i] != b[i])
                return false;
        }
        return true;
    }
    ScanProfile.equals = equals;
    function information_gain(profile) {
        let n = profile.length;
        let counts = [0, 0, 0, 0, 0, 0, 0, 0];
        profile.forEach((s) => counts[s]++);
        let gain = 0;
        // TODO: Somehow get rid of those branches
        if (counts[0] > 0)
            gain += counts[0] * Math.log2(n / counts[0]);
        if (counts[1] > 0)
            gain += counts[1] * Math.log2(n / counts[1]);
        if (counts[2] > 0)
            gain += counts[2] * Math.log2(n);
        if (counts[3] > 0)
            gain += counts[3] * Math.log2(n / counts[3]);
        if (counts[4] > 0)
            gain += counts[4] * Math.log2(n / counts[4]);
        if (counts[5] > 0)
            gain += counts[5] * Math.log2(n);
        gain /= n;
        return gain;
    }
    ScanProfile.information_gain = information_gain;
    class ScanProfileEquivalenceClass {
        constructor(id, profile, area) {
            this.id = id;
            this.profile = profile;
            this.area = area;
            this.information_gain = ScanProfile.information_gain(profile);
        }
    }
    ScanProfile.ScanProfileEquivalenceClass = ScanProfileEquivalenceClass;
    class ScanEquivalenceClasses {
        constructor(options) {
            this.options = options;
            this.raster = null;
            this.equivalence_classes = null;
            if (this.options.candidates.length == 0) {
                this.max_information = 0;
                this.equivalence_classes = [];
                return;
            }
            const bounds = TileRectangle.translate(TileRectangle.extend(TileRectangle.from(...this.options.candidates), (this.options.complement ? (this.options.range + 15) : (2 * this.options.range)) + 1), { x: 0, y: this.options.complement ? 6400 : 0 });
            bounds.botright.y %= 12800;
            bounds.topleft.y %= 12800;
            this.raster = new Raster(bounds);
            this.equivalence_classes = [];
            let next_id = 0;
            for (let row = 0; row < this.raster.size.y; row++) {
                for (let col = 0; col < this.raster.size.x; col++) {
                    let index = row * this.raster.size.x + col;
                    let tile = {
                        x: this.raster.bounds.topleft.x + col,
                        y: this.raster.bounds.botright.y + row,
                        level: this.options.floor
                    };
                    let profile = ScanProfile.compute(tile, this.options.candidates, this.options.range);
                    if (col > 0) {
                        let left_neighbour = this.raster.data[index - 1];
                        if (ScanProfile.equals(profile, left_neighbour.profile)) {
                            this.raster.data[index] = left_neighbour;
                            left_neighbour.area.push(index);
                            continue;
                        }
                    }
                    if (row > 0) {
                        let down_neighour = this.raster.data[index - this.raster.size.x];
                        if (ScanProfile.equals(profile, down_neighour.profile)) {
                            this.raster.data[index] = down_neighour;
                            down_neighour.area.push(index);
                            continue;
                        }
                    }
                    // Create new equivalence class
                    this.raster.data[index] = new ScanProfileEquivalenceClass(next_id++, profile, [index]);
                    this.equivalence_classes.push(this.raster.data[index]);
                }
            }
            this.max_information = Math.max(...this.equivalence_classes.map((c) => c.information_gain));
        }
    }
    ScanProfile.ScanEquivalenceClasses = ScanEquivalenceClasses;
})(ScanProfile || (ScanProfile = {}));
